import React from 'react';
import { IHeaderNavigationItem } from '../../../../../../interfaces';
import { IHeaderContentItems } from '../interface';

import { Link } from './Link';
import { SearchCruise } from './SearchCruise';

export class MenuItemLink extends React.Component<
    { className?: string; item: IHeaderNavigationItem },
    {}
> {
    render() {
        return (
            <Link
                className={this.props.className}
                href={this.props.item.targetUrl}
                followLink
                {...({} as any)}
            >
                <span
                    style={{
                        fontSize: '13.992px',
                        fontFamily: 'Arial, Helvetica, sans-serif',
                    }}
                >
                    {this.props.item.title}
                </span>
            </Link>
        );
    }
}

export class MenuItem extends React.Component<IHeaderNavigationItem, {}> {
    render() {
        let dropdownChildren;
        // prevent empty list rendering
        if (this.props.children && this.props.children.length > 0) {
            dropdownChildren = (
                <MenuItemList className="dropdown-menu" items={this.props.children} />
            );
        }

        const getClassName = (identifier: string) => {
            if (identifier) {
                return identifier;
            } else {
                return 'nav-main-link';
            }
        };

        return (
            <li className={this.props.isActive ? 'active' : ''}>
                <MenuItemLink
                    className={getClassName(this.props.identifier || '')}
                    item={this.props}
                />
                {dropdownChildren}
            </li>
        );
    }
}

export class MenuItemList extends React.Component<
    { className?: string; items: IHeaderNavigationItem[] },
    {}
> {
    render() {
        return (
            <ul className={this.props.className} role="menu">
                {this.props.items && this.props.items.length > 0
                    ? this.props.items.map((item, key) => (
                          <MenuItem
                              key={key}
                              {...item}
                              isActive={(item as any).icon === 'homepage'}
                          />
                      ))
                    : null}
            </ul>
        );
    }
}

export class HeaderMainNavigation extends React.Component<
    { items: IHeaderContentItems; isCollapsed?: boolean },
    {}
> {
    /** Collect the nav links, forms, and other content for toggling */
    static defaultProps = {
        isCollapsed: true,
    };

    render() {
        return (
            <div
                className={this.props.isCollapsed ? 'collapse navbar-collapse' : ''}
                id="globalPage_navigation"
            >
                <MenuItemList
                    className="nav navbar-nav navbar-a-test"
                    items={this.props.items.mainNavigation}
                />
                <SearchCruise className="visible-lg" />
            </div>
        );
    }
}
